import { Controller } from "@hotwired/stimulus";

// Makes a set of sibling <details> behave as an exclusive accordion: opening one
// collapses the others, so only a single group is expanded at a time. Attached to
// the wrapper around the CSS-variable groups (shared by the shop Appearance section
// and the variant Appearance section), so both pages get the behaviour.
//
// The native `toggle` event does not bubble, but it still reaches a capturing
// listener on the ancestor — so we listen in the capture phase instead of on each
// <details> individually.
export default class extends Controller {
  connect() {
    this.onToggle = this.onToggle.bind(this);
    this.element.addEventListener("toggle", this.onToggle, true);
  }

  disconnect() {
    this.element.removeEventListener("toggle", this.onToggle, true);
  }

  groups() {
    return Array.from(this.element.children).filter((el) => el.tagName === "DETAILS");
  }

  onToggle(event) {
    const opened = event.target;
    if (!opened.open || !this.groups().includes(opened)) return;
    this.groups().forEach((other) => {
      if (other !== opened && other.open) other.open = false;
    });
  }
}
